import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export const trackClickEditAppletSettings = appletId => {
  logIFTTTNextAction("click", {
    object_type: "edit_connection_settings",
    object_id: appletId,
    location_type: "diy_composer",
  })
}

// phase 2
export const trackClickEditApplet = appletId => {
  logIFTTTNextAction("click", {
    object_type: "edit_connection",
    object_id: appletId,
    location_type: "diy_composer",
  })
}

export const trackClickAddTrigger = ({ step }) => {
  logIFTTTNextAction("click", {
    object_type: `add_${step}_button`,
    location_type: "diy_composer",
  })
}

export const trackClickAddFilterCodeButton = () => {
  logIFTTTNextAction("click", {
    object_type: "add_filter_code_button",
    location_type: "diy_composer",
  })
}

export const trackClickAddDelayButton = () => {
  logIFTTTNextAction("click", {
    object_type: "add_delay_action_button",
    location_type: "diy_composer",
  })
}

export const trackClickAddQueryButton = () => {
  logIFTTTNextAction("click", {
    object_type: "add_query_button",
    location_type: "diy_composer",
  })
}

export const trackClickAddMoreStepButton = ({ stepType }) => {
  logIFTTTNextAction("click", {
    object_type:
      stepType === "trigger"
        ? "add_filter_code_query_plus_button"
        : "add_action_plus_button",
    location_type: "diy_composer",
  })
}

export const trackClickCancelButton = () => {
  logIFTTTNextAction("click", {
    object_type: "cancel_button",
    location_type: "diy_composer",
  })
}

export const trackClickContinueButton = () => {
  logIFTTTNextAction("click", {
    object_type: "continue_button",
    location_type: "diy_composer",
  })
}

export const trackClickPreviewAppletFinish = () => {
  logIFTTTNextAction("click", {
    object_type: "finish_button",
    location_type: "diy_preview_page",
  })
}

export const trackClickStepDeleteButton = ({ stepIdentifier, stepType }) => {
  logIFTTTNextAction("click", {
    object_type: `delete_${stepType}_button`,
    object_id: stepIdentifier,
    location_type: "diy_composer",
  })
}

export const trackClickFilterCodeEditButton = () => {
  logIFTTTNextAction("click", {
    object_type: "edit_filter_code_button",
    location_type: "diy_composer",
  })
}

export const trackClickDelayEditButton = () => {
  logIFTTTNextAction("click", {
    object_type: "edit_delay_action_button",
    location_type: "diy_composer",
  })
}

export const trackClickServiceSelected = ({ serviceModuleName, stepType }) => {
  logIFTTTNextAction("click", {
    object_type: "service",
    object_id: serviceModuleName,
    location_type: `diy_${stepType}_service_selection`,
  })
}

export const trackClickServiceStepSelected = ({ stepIdentifier, stepType }) => {
  logIFTTTNextAction("click", {
    object_type: `${stepType}_card`,
    object_id: stepIdentifier,
    location_type: `diy_${stepType}_selection`,
  })
}

export const trackClickServiceConfigured = ({ stepType }) => {
  logIFTTTNextAction("click", {
    object_type: `create_${stepType}_button`,
    location_type: `diy_${stepType}_field_config`,
  })
}

export const trackPageviewPreview = () => {
  logIFTTTNextAction("page_viewed", {
    location_type: "diy_preview_page",
  })
}

export const trackStateChangeAppletCreation = ({ appletId }) => {
  logIFTTTNextAction("statechange", {
    object_type: "connection",
    object_id: appletId,
    location_type: "diy_preview_page",
    location_id: appletId,
    state: "created",
  })
}

export const trackStateChangeFilterCodeCreated = () => {
  logIFTTTNextAction("statechange", {
    object_type: "filter_code",
    state: "created",
    location_type: "diy_filter_code",
  })
}

export const trackStateChangeDelay = state => {
  logIFTTTNextAction("statechange", {
    object_type: "delay",
    state,
    location_type: "diy_delay",
  })
}

export const trackStateChangeServiceConnected = ({
  serviceModuleName,
  stepType,
}) => {
  logIFTTTNextAction("statechange", {
    object_type: "service",
    object_id: serviceModuleName,
    state: "connected",
    location_type: `diy_${stepType}_service_authentication`,
  })
}

export const trackSystemStepConfigSkipped = ({
  serviceModuleName,
  stepType,
}) => {
  logIFTTTNextAction("system", {
    object_type: stepType,
    object_id: serviceModuleName,
    location_type: `diy_${stepType}_field_config`,
    object_status: "config_skipped",
  })
}

export const trackSystemServiceConnectionSkipped = ({
  serviceModuleName,
  stepType,
}) => {
  logIFTTTNextAction("system", {
    object_type: "service",
    object_id: serviceModuleName,
    location_type: `diy_${stepType}_service_authentication`,
    object_status: "auth_skipped",
  })
}

export const trackStateChangeAppletUpdated = appletId => {
  logIFTTTNextAction("statechange", {
    object_type: "connection_updated",
    object_id: appletId,
    location_type: "diy_composer",
  })
}

export const trackStateChangeMakeItYourOwn = ({ appletId }) => {
  logIFTTTNextAction("statechange", {
    object_type: "make_it_your_own",
    object_id: appletId,
    location_type: "diy_composer",
    location_id: appletId,
  })
}
